import React,{useState} from "react";
import { Link } from "react-router-dom";

import bg1 from "../assets/images/bg/budgeting1.webp"
import about from "../assets/images/about.jpg"
import cta from "../assets/images/cta.jpg"

import NavbarTwo from "../components/navbar/navbarTwo"
import ClientTwo from "../components/client/clientTwo";
import Partners from "../components/partners";
import Team from "../components/team";
import FooterThree from "../components/footer/footerThree";
import ScrollTop from "../components/scrollTop";
import { HashLink } from 'react-router-hash-link';
import { scrollWithOffset } from "../utils/scrollUtils";

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/css/modal-video.css';

import {AiOutlineCheckCircle, FiAirplay, LiaReact, FiUsers,FiArrowRight} from '../assets/icons/vander'
import CountUp from 'react-countup';

export default function AboutUs(){
    return (
        <>
        <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light"/>

        <section id="page-top" className="bg-half-170 d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="bg-overlay bg-gradient-overlay"></div>
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-12">
                        <div className="title-heading text-center">
                            <h5 className="heading fw-semibold mb-0 page-heading text-white title-dark">Budgeting 101: Because "YOLO" Isn't a Financial Strategy</h5>
                            <small className="text-white-50 mb-1 fw-medium text-uppercase mx-auto">A survival guide for individuals, couples, new families, new homeowners, and <u>anyone</u> whose bank balance makes them question their life choices</small>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="section-title">
                            <div className="text-muted2">
                                <div>
                                <p><h5><b>Note to the reader:</b></h5> I am going to let you in on a little secret.  <br></br><br></br>My family has been in and out of debt so many times, I've lost count.  It's life.  Just know that EVERY family goes through this.  EVERY person, couple, and throuple will go through this. <u>So trust me when I tell you that you CAN conquer your finances, and it all starts with a plan.</u></p><hr></hr>
                                <p><strong>Welcome to the club nobody wanted to join, but everyone is in (or will be) at some point in their lives.</strong></p>
                                <p>You know the one: the "Holy crap, where did all my money go?" club. The "Ramen noodles are a food group, right?" club.</p>
                                <p>Here's the good news: You're not broken. Your situation isn't hopeless. And no, you don't need to live like a hermit eating beans out of a can to get your finances together.</p>
                                <p>You just need a plan that doesn't suck. Let's build one.</p>
                                <hr />
                                <h4>Step 1: The Financial Autopsy (Don't Worry, Nothing's Actually Dead... Yet)</h4>
                                <p>Time to put on your detective hat and solve the mystery of "Where the hell did my money go?"</p>
                                <ul>
                                <li>Grab your last 2 months of bank and credit card statements</li>
                                <li>Sort everything into categories: Housing, Food, Bills, Gas, Questionable tattoos at 2 AM, etc.</li>
                                <li>Try not to have a complete existential crisis when you see how much you spend on coffee each month. My wife and I love coffee. Is $130/month too much?</li>
                                </ul>
                                <p><strong>Pro Tip:</strong> That $4.99 "small" software subscription you forgot about and don't use? It's been quietly draining your account like a financial vampire. Find it. Cancel it. Feel powerful.</p>
                                <hr />
                                <h4>Step 2: Dream Big (Then Make a Plan That Won't Require Selling a Kidney)</h4>
                                <p>Here's where we get philosophical. What do you actually want your money to do for you?</p>
                                <ul>
                                <li>What would make you sleep better at night?</li>
                                <li>What's one thing that would make you feel like you're winning at life?</li>
                                <li>If money stress disappeared tomorrow, what would you do with all that mental energy?</li>
                                <li>Money is just a tool. You get to use it as you see fit. Make it work for you, and not for the credit card companies.</li>
                                </ul>
                                <p><strong>Write it down.</strong> Make it real. Tape it to your bathroom mirror. Goals that aren't written down are just expensive daydreams.</p>
                                <hr />
                                <h4>Step 3: Build a Budget That Doesn't Make You Want to Cry</h4>
                                <p>Time for the main event: creating a budget that you'll actually use, instead of ignoring like that Planet Fitness membership (Don't get me started. FU Planet Fitness!).</p>
                                <p>Will it be painful?  Sure, every change that requires a bit of discipline will bring a little pain. But remember, we're going for "sustainable life improvement," not "financial boot camp that breaks your soul."</p> <p>Here's the breakdown you are looking for:</p>
                                <ul>
                                <li><strong>Essentials (50–60%):</strong> Rent, utilities, groceries, gas, phone bill, and that one streaming service you actually watch</li>
                                <li><strong>Life Worth Living (20–30%):</strong> Date nights, hobbies, the occasional "treat yourself" moment that keeps you sane</li>
                                <li><strong>Future You Fund (15–25%):</strong> Savings, debt destruction, emergency fund</li>
                                </ul>
                                <p><strong>Oh, remember that note about pain?</strong> If you're drowning in debt, your "Life Worth Living" category might need to become "Life Worth Surviving" for a while. That's okay. This isn't forever. It's just for now. That said, build in some "self-care" money into your monthly budget.  We all need that.  Just don't go crazy and instead, focus on paying down your debt as fast as you can. (Here is a great tool to help you do that.)</p>
                                <hr />
                                <h4>Step 4: Track | Like Your Financial Life Depends on It (Because It Does)</h4>
                                <ul>
                                <li>Apps (Mint, YNAB, or whatever doesn't make you want to throw your phone)</li>
                                <li>Spreadsheets (for people who enjoy mild torture)</li>
                                <li>Notebook (surprisingly therapeutic)</li>
                                <li>Envelope method (cash only – terrifying but effective)</li>
                                </ul>
                                <p><strong>The goal isn't perfection.</strong> It's awareness.</p>
                                <hr />
                                <h4>Step 5: The Great Spending Purge (Marie Kondo Meets Your Bank Account)</h4>
                                <ul>
                                <li>Subscriptions you forgot existed</li>
                                <li>Delivery fees that cost more than the actual food</li>
                                <li>"Just this once" purchases that happen three times a week</li>
                                <li>Buying new instead of second-hand</li>
                                </ul>
                                <p><strong>The Magic Question:</strong> "Do I want this more than I want my goal?"</p>
                                <hr />
                                <h4>Step 6: Debt Destruction Mode (Activate!)</h4>
                                <ul>
                                <li><strong>Debt Avalanche:</strong> Attack the highest interest rate first, pay minimums on everything else.</li>
                                <li><strong>Debt Snowball:</strong> Start with the smallest balance, when that's paid off, roll the extra into the next largest debt, repeat.</li>
                                <li><strong>Check out this calculator</strong> - Debt Reduction Calculator. Best debt tracking tool ever!</li>
                                </ul>
                                <p><strong>The Secret Sauce:</strong> Pay minimums on everything else, and throw every extra dollar at your target.</p>
                                <hr />
                                <h4>Step 7: The "Oh Shit" Fund (Emergency Savings)</h4>
                                <p>Aim for $500–$1,000 in a "stuff happens" fund.</p>
                                <ul>
                                <li>Sell stuff</li>
                                <li>Cancel subscriptions</li>
                                <li>Side gig</li>
                                <li>No-spend week</li>
                                </ul>
                                <p><strong>Plenty of ways to build this up:</strong> Having money in the bank and paying off debt, feels pretty good actually.  Go for the feels!</p>
                                <hr />
                                <h4>Step 8: Automate Everything (Become a Lazy Genius)</h4>
                                <ul>
                                <li>Bills → Auto-pay</li>
                                <li>Savings → Auto-transfer</li>
                                <li>Investments → Auto-invest</li>
                                </ul>
                                <p><strong>Technology</strong> = your accountability buddy.</p>
                                <hr />
                                <h4>Step 9: The Monthly Money Date (With or Without Drinks)</h4>
                                <p>Check in on your progress once a month.  Tweak your goals if you need to, but don't lose sight of the end game.  Travel fund, tuition payment, debt payoff, whatever it is stick to it.</p>
                                <ul>
                                <li>What worked this month?</li>
                                <li>Where did we completely lose our minds?</li>
                                <li>What should we celebrate?</li>
                                <li>What needs tweaking?</li>
                                </ul>
                                <p>Make it a habit. This one is important. Hold yourself accountable.</p>
                                <hr />
                                <h4>Step 10: Embrace discomfort. (You're Human)</h4>
                                <p>You'll blow your budget, you'll spend too much, you'll regret some decisions. You'll mess up. You'll learn. You'll grow.</p>
                                <p>Making mistakes is part of the process.  Just don't repeat them.  Strive for growth.</p>
                                <p>Budgeting is not about perfection. It's about progress.</p>
                                <hr />
                                <h4>The Bottom Line (Literally)</h4>
                                <p>Don't look at a budget as its restricting you. A budget is about permission. You give yourself permission to spend money on what matters to you, and to say no to what doesn't. You’ve got a plan.</p>
                                <p><strong>Your future self is counting on you. You've got this.</strong></p>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>

        <FooterThree/>
        <ScrollTop/>
         </>
    )
}